/**
 * Full-page navigation, as opposed to a client-side route transition.
 *
 * The sign-in confirm interstitial (src/app/(main)/auth/confirm/page.tsx)
 * must land on /api/auth/callback, a Route Handler rather than a Next.js
 * page - next/navigation's router is not a substitute here. Kept in its own
 * module so tests can mock it: jsdom (30.x, as pinned in this repo) defines
 * window.location and its methods as non-configurable and non-writable, so
 * they cannot be intercepted directly from a test.
 */
export function hardNavigate(url: string): void {
  window.location.replace(url);
}
